import { styled } from '@sds-system/system';
import { getAllStyledProps } from '@sds-system/utils';
import { Row } from '../Row';
import type { StyledPaginationProps } from './Pagination.types';

export const StyledPaginationWrapper = styled(Row)<StyledPaginationProps>(() => {
  return {};
}, getAllStyledProps);
